import { StyledMainTitle } from '@/Views/BeforeLogin/BeforeLogin.styles';
import styled from 'styled-components';

export const StyledBookADemoTitle = styled(StyledMainTitle)`
  color: ${(props) => props.theme.sameColorPurple} !important;
`;
